import react, { useEffect } from "react";
import ConfetiiPice from './ConfettiPiece'
import { useNavigate } from "react-router-dom";

const Finish = ({ visible, form, plan_id }) => {
    const navigate = useNavigate();
    const isError = form && (form.danger || form.warning) && (form.danger.length > 0/* || form.warning.length > 0*/) ? true : false;



    // useEffect(() => {
    //     if (visible && !isError) {
    //         //my/billing/checkout/40/finish
    //         navigate(`/my/billing/checkout/${plan_id}/finish`);
    //     }
    // }, [visible])


    const onSuccess = () => {
        return (
            <div className="row">
                <div className="col-12 text-center">
                    <h2 className="dashboard-h2"><span>PARABÉNS</span> </h2><br />
                    <h6 style={{ lineHeight: '28px' }}>ACABOU DE CONCLUIR O REGISTO DO SEU LOCAL <br /> DENTRO DE ALGUNS INSTANTES ESTARÁ DISPONÍVEL NA NOSSA PLATAFORMA.</h6>
                </div>
            </div>
        )
    }


    const onError = () => {
        const ListDanger = () => {
            return form.danger.map((item, index) => {
                return <li key={index}>{item}</li>
            });
        }





        return (
            <div className="row">
                <div className="col-12 ">
                    <div className="alert alert-danger" role="alert">
                        <h4 className="alert-heading">Oh, crap ☹️</h4>
                        <p className="mb-0">É necessário fornecer algumas informações para completar o perfil do local.</p>
                        <p className="mb-0">Não se preocupe, as informações que já forneceu estão guardadas.</p>
                        <hr />
                        Avisos
                        <ListDanger />
                    </div>

                </div>
            </div>
        )
    }


    return (
        <div className="finish" style={{ display: !visible ? 'none' : 'block', height: '30vh' }}>
            <div className="row" >
                <div className="col-12">
                    {isError ? onError() : onSuccess()}
                </div>

            </div>

        </div>
    )
}

export default Finish;